import MainLayout from './MainLayout';
import { MainLayoutProps, MainLayoutValueProps } from './types';

export type { MainLayoutProps, MainLayoutValueProps };
export default MainLayout;
